var exports = {
  "wQ": "SudoVerificationModal.module__passkeyVerifying___c3I2dn",
  "hU": "SudoVerificationModal.module__unavailable___c3I2dn",
  "TJ": "SudoVerificationModal.module__unavailableTitle___c3I2dn",
  "$r": "SudoVerificationModal.module__unavailableBody___c3I2dn",
  "zc": "SudoVerificationModal.module__formError___c3I2dn",
  "kK": "SudoVerificationModal.module__passkeyHint___c3I2dn",
};

module.exports = exports;
